// mapare tabele si utilitare pentru anul scolar

import { supabase } from './supabase';

const USE_V2_TABLES = true;

// Mapare nume tabele
export const TABLES = {
  profiles: USE_V2_TABLES ? 'profiles_v2' : 'profiles',
  credit_requests: USE_V2_TABLES ? 'credit_requests_v2' : 'credit_requests',
  credit_types: USE_V2_TABLES ? 'credit_types_v2' : 'credit_types',
  credits_obtained: USE_V2_TABLES ? 'credits_obtained_v2' : 'credits_obtained',
  modules: USE_V2_TABLES ? 'modules_v2' : 'modules',
  notifications: USE_V2_TABLES ? 'notifications_v2' : 'notifications',
  predefined_activities: USE_V2_TABLES ? 'predefined_activities_v2' : 'predefined_activities',
  specializations: USE_V2_TABLES ? 'specializations_v2' : 'specializations',
  
  // tabele adaugate ulterior
  credits_by_category: 'credits_by_category_v2',
  student_class_history: 'student_class_history_v2',
  credit_transactions: 'credit_transactions_v2',
  benefits: 'benefits_v2',
  benefit_usage: 'benefit_usage_v2',
  audit_log: 'audit_log_v2',
};

// relatii pentru join-uri in select
export const RELATIONS = {
  modules: USE_V2_TABLES ? 'modules_v2' : 'modules',
  credit_types: USE_V2_TABLES ? 'credit_types_v2' : 'credit_types',
  profiles: USE_V2_TABLES ? 'profiles_v2' : 'profiles',
  predefined_activities: USE_V2_TABLES ? 'predefined_activities_v2' : 'predefined_activities',
};

// nume FK pentru join-uri cu alias
export const FK_NAMES = {
  credit_requests_id_elev: USE_V2_TABLES ? 'credit_requests_v2_id_elev_fkey' : 'credit_requests_id_elev_fkey',
  credit_requests_id_validator: USE_V2_TABLES ? 'credit_requests_v2_id_validator_fkey' : 'credit_requests_id_validator_fkey',
};

export const getRelation = (obj, relationName) => {
  if (!obj) return null;
  return obj[`${relationName}_v2`] || obj[relationName] || null;
};

export const getModules = (obj) => getRelation(obj, 'modules');
export const getCreditTypes = (obj) => getRelation(obj, 'credit_types');
export const getProfiles = (obj) => getRelation(obj, 'profiles');
export const getPredefinedActivities = (obj) => getRelation(obj, 'predefined_activities');

export const VIEWS = {
  elev_dashboard: USE_V2_TABLES ? 'elev_dashboard_v2' : 'elev_dashboard',
  student_summary: 'student_summary_v2',
};

export const getCurrentSchoolYear = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  const year = now.getFullYear();
  
  if (month >= 9) {
    return `${year}-${year + 1}`;
  } else {
    return `${year - 1}-${year}`;
  }
};

// Anii scolari prezenti in tabelul dat, descrescator
export const getSchoolYears = async (table = 'credit_requests_v2') => {
  const { data } = await supabase.from(table).select('an_scolar').not('an_scolar', 'is', null);
  return [...new Set((data || []).map((r) => r.an_scolar))].sort().reverse();
};

// Alege anul curent daca are date, altfel ultimul an cu date
export const resolveSchoolYear = (years = []) => {
  const current = getCurrentSchoolYear();
  if (years.includes(current)) return current;
  return years[0] || current;
};

export const CREDIT_CATEGORIES = {
  CURRICULAR: 'curricular',
  EXTRACURRICULAR: 'extracurricular',
  TRANSFERABIL: 'transferabil',
};

export const TRANSACTION_TYPES = {
  TRANSFER_AN: 'transfer_an',
  TRANSFER_MODUL: 'transfer_modul',
  UTILIZARE: 'utilizare',
  EXPIRARE: 'expirare',
  AJUSTARE: 'ajustare',
  BONUS: 'bonus',
};

export const CLASS_CHANGE_REASONS = {
  PROMOVARE: 'promovare',
  TRANSFER: 'transfer',
  REPETENT: 'repetent',
  CORECTIE: 'corectie',
};

export default TABLES;
